import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RebateStatusActionMixin from '@/helpers/vue_mixins/v2/super_mini_app/add_ons/RebateStatusActionMixin';
import { RebateStatus } from '@/helpers/entities/enums/v2/RebateStatus';
import RebateApprove from '@/plugins/graphql/mutations/v2/store_add_ons/rebate-approve.gql';
import RebateStatusesQuery from '@/plugins/graphql/queries/v2/store_add_ons/rebates-by-status.gql';
import { required } from 'vuelidate/lib/validators';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { validationMixin } from 'vuelidate';
let VoucherConfirmation = class VoucherConfirmation extends Mixins(ViewportSizeMixin, RebateStatusActionMixin, validationMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            rejectMessage: null,
        };
        this.cardTitle = '';
        this.cardTextMessage = '';
        this.status = '';
        this.successUpdateMessage = '';
    }
    setConfirmationData() {
        this.cardTitle = 'Approve';
        this.cardTextMessage = 'approve';
        this.status = 'approved';
        this.successUpdateMessage = 'Voucher Approved';
    }
    setRejectionData() {
        this.cardTitle = 'Reject';
        this.cardTextMessage = 'reject';
        this.status = 'rejected';
        this.successUpdateMessage = 'Voucher Rejected';
    }
    showDialog() {
        if (this.showConfirmationDialog) {
            this.toggleDialog = !this.toggleDialog;
        }
    }
    async uponConfirm() {
        if (this.rejectDialog) {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.submit();
            }
        }
        if (this.confirmDialog) {
            this.submit();
        }
    }
    async submit() {
        this.requestOnFlight();
        await this.update()
            .then(() => {
            const msg = successfulUpdate(this.successUpdateMessage);
            this.successNotification(msg);
            this.$router.push({
                name: 'submissions-by-status',
                params: { status: this.status },
            });
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update() {
        const currentStatus = this.status;
        const prevStatus = RebateStatus.Pending;
        const appUuid = this.appUUID;
        const vm = this;
        let cancelMessage = '';
        if (this.form) {
            cancelMessage = this.form.rejectMessage;
        }
        return this.$apollo.mutate({
            mutation: RebateApprove,
            variables: {
                input: {
                    rebateUuid: vm.rebateUuid,
                    status: currentStatus,
                    cancelMessage,
                },
            },
            update(cache, { data }) {
                const updatedRebate = data.rebateStatusUpdate.rebate;
                vm.updateRebateStatusCache(prevStatus, currentStatus, updatedRebate, vm.rebateUuid, appUuid, cache);
            },
            refetchQueries: [
                {
                    query: RebateStatusesQuery,
                    variables: {
                        appUuid,
                        status: prevStatus,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], VoucherConfirmation.prototype, "showConfirmationDialog", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], VoucherConfirmation.prototype, "confirmDialog", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], VoucherConfirmation.prototype, "rejectDialog", void 0);
__decorate([
    Watch('confirmDialog')
], VoucherConfirmation.prototype, "setConfirmationData", null);
__decorate([
    Watch('rejectDialog')
], VoucherConfirmation.prototype, "setRejectionData", null);
__decorate([
    Watch('showConfirmationDialog')
], VoucherConfirmation.prototype, "showDialog", null);
VoucherConfirmation = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
        },
        validations: {
            form: {
                rejectMessage: {
                    required,
                },
            },
        },
    })
], VoucherConfirmation);
export default VoucherConfirmation;
